<template>
  <c-modal class-name="profile-field-add-dictionary-modal" :active="displayModal" :title="title" @close="close">
    <form @submit.prevent="submit">
      <div
        class="form-group"
        :class="{
          'is-invalid': isSubmitted && errorText,
        }"
      >
        <c-textarea
          v-model="variantsString"
          placeholder="Значения"
          :clearable="true"
          class="form__field"
          :error="isSubmitted && errorText"
          :invalid="isSubmitted && errorText"
        />
        <div v-if="!(isSubmitted && errorText)" class="form-note">Введите варианты списка по одному в строке</div>
      </div>
    </form>

    <template #actions>
      <c-button
        responsive
        label="Сбросить"
        :icon="{
          icon: 'close',
          color: 'secondary',
        }"
        @click="close"
      />
      <c-button
        responsive
        label="Применить"
        :icon="{
          icon: 'check',
          color: 'green',
        }"
        @click="addVariants"
      />
    </template>
  </c-modal>
</template>

<script>
import CTextarea from "@/components/controls/textarea";
import CButton from "@/components/controls/button";
import CModal from "@/components/scrollable-modal";

export default {
  components: {
    CTextarea,
    CButton,
    CModal,
  },
  props: ["fieldName", "list"],
  data() {
    return {
      displayModal: false,
      isSubmitted: false,
      variantsString: "",
    };
  },

  computed: {
    title() {
      return `Редактировать справочник поля <span class="font-weight-normal">${this.fieldName || ""}</span>`;
    },
    variants() {
      return this.variantsString
        .split("\n")
        .map((v) => v.trim())
        .filter(Boolean);
    },
    repeatedValues() {
      const dict = {};
      this.variants.forEach((v) => {
        if (v in dict) dict[v] += 1;
        else dict[v] = 1;
      });
      return Object.keys(dict).filter((key) => dict[key] > 1);
    },
    valuesInList() {
      if (!this.list.length) return [];
      const normalizedList = this.list.map((v) => v.toLowerCase());
      return this.variants.filter((variant) => normalizedList.includes(variant.toLowerCase()));
    },
    errorText() {
      if (this.valuesInList.length) {
        return `Следующие значения уже есть в справочнике:<br>${this.valuesInList.join("<br>")}`;
      }

      if (this.repeatedValues.length) {
        return `Значения ${this.repeatedValues.join(", ")} повторяются несколько раз`;
      }

      return "";
    },
    isValid() {
      return !this.valuesInList.length && !this.repeatedValues.length;
    },
  },

  methods: {
    open() {
      this.displayModal = true;
    },

    close() {
      this.displayModal = false;
      this.reset();
      this.$emit("close");
    },

    reset() {
      this.variantsString = "";
      this.isSubmitted = false;
    },

    addVariants() {
      this.isSubmitted = true;

      if (!this.isValid) return;

      if (this.variants.length) {
        this.$emit("add", this.variants);
      }

      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  .c-input-required {
    position: static;
    height: auto;
    margin-top: 7px;
    align-items: flex-start;

    .c-input-required-text {
      white-space: normal!important;
      line-height: 1.2;
    }
  }
}
</style>

<style>
.profile-field-add-dictionary-modal {
  max-width: 590px !important;
}
</style>
